<template>
  <tuango-portlet class="box blue">
    <div slot="title" class="portlet-title">
      <div slot="caption" class="caption">
        <i class="icon-wallet"></i>
        <slot>Transactions</slot>
      </div>
      <div slot="actions" class="actions">
      </div>
    </div>

    <div slot="body" v-loading.body.lock="loading">
      <tuango-datatables :tableData="trx"
                         :headers="headers"
                         :buttons="buttons"></tuango-datatables>
    </div>
  </tuango-portlet>
</template>

<script>
  import TransactionTransformer from '@/app/transformers/TransactionTransformer'
  import TuangoDatatables from '@/app/components/datatables/Datatable'
  import TuangoPortlet from '@/app/components/Portlet'

  export default {
    name: 'table-trx',
    props: {
      customerId: {
        type: String,
        required: true
      }
    },
    components: {
      TuangoDatatables,
      TuangoPortlet
    },
    data () {
      return {
        loading: false,
        headers: [
          {prop: 'captureTrxUid', title: '#'},
          {title: 'trxDate', prop: 'trxDate'},
          {title: 'offerId', prop: 'offerId'},
          {title: 'offerName', prop: 'offerName'},
          {prop: 'locationName', title: 'Location Name'},
          {prop: 'ccUID', title: 'Credit Card Used'},
          {title: 'ccNumber', prop: 'ccNumber'},
          {title: 'transactionSequenceNumber', prop: 'transactionSequenceNumber'},
          {title: 'amount', prop: 'amount'},
          {title: 'cashbackAmount', prop: 'cashbackAmount'},
          {title: 'status', prop: 'status'}
        ],
        trx: [],
        buttons: [
          {
            extend: 'copy',
            className: 'dt-button btn default'
          },
          {
            extend: 'print',
            className: 'dt-button btn default'
          },
          {
            extend: 'csv',
            className: 'dt-button btn default'
          }
        ]
      }
    },
    methods: {
      getUserTransactions () {
        this.$api.transactionsCustIdGet(
          {
            cust_id: this.customerId
          })
          .then(res => {
            this.trx = TransactionTransformer.fetchCollection(res['data'])
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$notify.error({
              title: 'Error',
              message: 'Error occured'
            })
            this.loading = false
          })
      }
    },
    watch: {
      customerId () {
        this.getUserTransactions()
      }
    },
    created () {
      this.loading = true
      this.getUserTransactions()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/components/user/Transactions.vue